module.exports = __webpack_public_path__ + "img/li.a93436b8.svg";